<template>
  <div class="container py-5" style="max-width: 500px">
    <h2 class="mb-4 text-center">Cadastro</h2>
    <form @submit.prevent="register">
      <div class="mb-3">
        <label for="nome" class="form-label">Nome completo</label>
        <input type="text" v-model="nome" class="form-control" id="nome" required />
      </div>
      <div class="mb-3">
        <label for="email" class="form-label">E-mail</label>
        <input type="email" v-model="email" class="form-control" id="email" required />
      </div>
      <div class="mb-3">
        <label for="senha" class="form-label">Senha</label>
        <input type="password" v-model="senha" class="form-control" id="senha" required />
      </div>
     
      <button type="submit" class="btn btn-success w-100">Cadastrar</button>
    </form>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: "RegisterVie",
  data() {
    return {
      nome: "",
      email: "",
      senha: "",
      tipo: "candidato",
    };
  },
  methods: {
    async register() {
      try {
        await api.post('register.php', {
          nome: this.nome,
          email: this.email,
          senha: this.senha,
          tipo: this.tipo,
        });

        // Não faz login automático!
        localStorage.removeItem('usuario');
        alert('Cadastro realizado com sucesso! Faça login para continuar.');
        this.$router.push('/login');
      } catch (error) {
        const erro = error.response?.data?.erro || 'Erro ao registrar usuário.';
        alert(erro);
        console.error('Erro no registro:', erro);
      }
    },
  },
};
</script>